import { MagnifyingGlassCircleIcon } from "@heroicons/react/24/solid";
import AlertModalConfirm from "components/AlertModal/AlertModalConfirm";
import { EntityDetails } from "components/FormDialog/EntityDetails";
import { AuthContext } from "context/appContext";
import { ProfilClient, Reservation } from "data/types";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { FC, useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";
import { fetchOwnerTransferts, payReservationOwner } from "redux/features/reservations/reservationSlice";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import Pagination from "shared/Pagination/Pagination";
import CommonLayout from "../AccountPage/CommonLayout";
import ReservationDetailsPage from "./reservationDetailsPage";
import StripeMenu from "./StripeMenu";
import useIsMobile from "hooks/isMobile";
import Badge from "shared/Badge/Badge";
import { FaEye } from "react-icons/fa";

export interface ClientTransfertsPageProps {
  className?: string;
}
interface ClientTransfertsPageLoadingState {
  [key: string]: boolean;
}
const ClientTransfertsPage: FC<ClientTransfertsPageProps> = ({ className = "" }) => {
  const authContext = useContext(AuthContext);
  let profile = authContext.user?.profil as ProfilClient;
  const [page, setPage] = useState(1);
  const dispatch = useAppDispatch();
  const reservations: Reservation[] = useAppSelector((state) => state.featureReservation.inProgress);
  const totalPages = useAppSelector((state) => state.featureReservation.totalPages);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState<ClientTransfertsPageLoadingState>({});
  const [showReservationDetails, setshowReservationDetails] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  useEffect(() => {
    if (profile) {
      dispatch(fetchOwnerTransferts({ pageNumber: page }));
    }
  }, [page, dispatch]);

  const giveOwnerPayment = async (reservation: any) => {
    setModalOpen(false);

    setIsLoading((prevState) => ({
      ...prevState,
      [reservation.id]: true,
    }));
    try {
      const res = await dispatch(payReservationOwner(reservation.reference));
      toast.success(res.payload.msg);
      setIsLoading((prevState) => ({
        ...prevState,
        [reservation.id]: false,
      }));

      dispatch(fetchOwnerTransferts({ pageNumber: page }));
      setIsLoading((prevState) => ({
        ...prevState,
        [reservation.id]: false,
      }));
    } catch (error) {
      console.error("Error processing payment:", error);
    }
  };

  const handlePageChange = (pageNumber: any) => {
    setPage(pageNumber);
  };

  const [selectedReservation, setselectedReservation] = useState<any | null>(null);
  const handleEyeIconClick = (client: any) => {
    setselectedReservation(client);
    setshowReservationDetails(true);
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const dateAvailable = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

  const isMobile = useIsMobile();

  return (
    <div className={`nc-AccountPage bg-neutral-50 ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>EventToBee | Location d'espaces : salles, lofts, jardins & boutiques – Paris & Île-de-France</title>
      </Helmet>
      <CommonLayout>
        <StripeMenu>
          <div className="flex items-center justify-center mb-4 md:justify-end">
            <div className="relative flex">
              <Input
                type="text"
                placeholder="Rechercher par code"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <MagnifyingGlassCircleIcon className="absolute w-6 h-6 text-gray-500 transform -translate-y-1/2 right-3 top-1/2" />
            </div>
          </div>
          {isMobile ? (
            <>
              {" "}
              {reservations &&
                reservations

                  .filter((item) => item.reference.toLowerCase().includes(searchTerm.toLowerCase()))
                  .map((item: any, index) => (
                    <div className="flex justify-center mt-2">
                      <div className="w-full max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                        <div className="flex justify-end px-4 pt-4">
                          <Badge
                            className="hover:bg-black hover:text-white"
                            name={
                              <FaEye
                                className="w-4 h-4 cursor-pointer"
                                onClick={() => handleEyeIconClick(item)}
                              ></FaEye>
                            }
                          ></Badge>
                        </div>
                        <div className="flex flex-col items-center pb-10">
                          <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">
                            {item.reference}
                          </h5>
                          <span className="text-sm text-gray-500 dark:text-gray-400">
                            A payer :{" "}
                            {(
                              parseFloat(item.halfTotal) +
                              (parseFloat(item.cleaning_costs) || 0) +
                              (isNaN(parseFloat(item.extra)) ? 0 : parseFloat(item.extra))
                            ).toFixed(2)}{" "}
                            €
                          </span>

                          <div className="flex mt-4 md:mt-6">
                            {item?.status === "paied" ? (
                              <span className="font-semibold text-secondary-6000">Virement réussi</span>
                            ) : item?.status === "Ok" ? (
                              <ButtonSecondary
                                loading={isLoading[item.id]}
                                onClick={() => {
                                  setselectedReservation(item);
                                  setModalOpen(true);
                                }}
                              >
                                {" "}
                                <span className="relative flex w-3 h-3">
                                  <span className="absolute inline-flex w-full h-full rounded-full opacity-75 animate-ping bg-sky-400"></span>
                                  <span className="relative inline-flex w-3 h-3 rounded-full bg-sky-500"></span>
                                </span>
                                <span className="ml-3">Transférer</span>
                              </ButtonSecondary>
                            ) : item?.status === "not allowed" ? (
                              <span className="font-semibold text-secondary-6000">
                                {" "}
                                <ButtonSecondary
                                  loading={isLoading[item.id]}
                                  onClick={() => {
                                    setselectedReservation(item);
                                    setFeedbackModalOpen(true);
                                  }}
                                >
                                  {" "}
                                  <span className="relative flex w-3 h-3">
                                    <span className="absolute inline-flex w-full h-full bg-red-400 rounded-full opacity-75 animate-ping"></span>
                                    <span className="relative inline-flex w-3 h-3 bg-red-500 rounded-full"></span>
                                  </span>
                                  <span className="ml-3">Réclamation</span>
                                </ButtonSecondary>{" "}
                              </span>
                            ) : item?.status === "pending" ? (
                              <span className="font-semibold text-black">En attente</span>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
            </>
          ) : (
            <div className="flex flex-col">
              <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-sm font-light text-center">
                      <thead className="font-medium text-white border-b bg-neutral-800 dark:border-neutral-500 dark:bg-neutral-900">
                        <tr>
                          <th scope="col" className="px-6 py-4 ">
                            Code
                          </th>

                          <th scope="col" className="px-6 py-4 ">
                            A Payer
                          </th>
                          <th scope="col" className="px-6 py-4 ">
                            Paiement
                          </th>
                          <th scope="col" className="px-6 py-4 ">
                            consulter
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {reservations &&
                          reservations

                            .filter((item) => item.reference.toLowerCase().includes(searchTerm.toLowerCase()))
                            .map((item: any, index) => (
                              <tr className="border-b dark:border-neutral-500" key={index}>
                                <td className="px-6 py-4 font-medium whitespace-nowrap">{item.reference}</td>
                                <td className="px-6 py-4 font-medium whitespace-nowrap">
                                  {(
                                    parseFloat(item.halfTotal) +
                                    (parseFloat(item.cleaning_costs) || 0) +
                                    (isNaN(parseFloat(item.extra)) ? 0 : parseFloat(item.extra))
                                  ).toFixed(2)}{" "}
                                  €
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                  {item?.status === "paied" ? (
                                    <span className="font-semibold text-secondary-6000">Virement réussi</span>
                                  ) : item?.status === "Ok" ? (
                                    <ButtonSecondary
                                      loading={isLoading[item.id]}
                                      onClick={() => {
                                        setselectedReservation(item);
                                        setModalOpen(true);
                                      }}
                                    >
                                      {" "}
                                      <span className="relative flex w-3 h-3">
                                        <span className="absolute inline-flex w-full h-full rounded-full opacity-75 animate-ping bg-sky-400"></span>
                                        <span className="relative inline-flex w-3 h-3 rounded-full bg-sky-500"></span>
                                      </span>
                                      <span className="ml-3">Transférer</span>
                                    </ButtonSecondary>
                                  ) : item?.status === "not allowed" ? (
                                    <span className="font-semibold text-secondary-6000">
                                      {" "}
                                      <ButtonSecondary
                                        loading={isLoading[item.id]}
                                        onClick={() => {
                                          setselectedReservation(item);
                                          setFeedbackModalOpen(true);
                                        }}
                                      >
                                        {" "}
                                        <span className="relative flex w-3 h-3">
                                          <span className="absolute inline-flex w-full h-full bg-red-400 rounded-full opacity-75 animate-ping"></span>
                                          <span className="relative inline-flex w-3 h-3 bg-red-500 rounded-full"></span>
                                        </span>
                                        <span className="ml-3">Réclamation</span>
                                      </ButtonSecondary>{" "}
                                    </span>
                                  ) : item?.status === "pending" ? (
                                    <span className="font-semibold text-black">En attente</span>
                                  ) : null}
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                  <i
                                    className="text-2xl cursor-pointer las la-eye"
                                    onClick={() => handleEyeIconClick(item)}
                                  ></i>{" "}
                                </td>
                              </tr>
                            ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="flex justify-end ">
            {/* <span className="text-sm text-gray-700">{count} élément</span> */}
          </div>
          {showReservationDetails && (
            <ReservationDetailsPage
              open={true}
              handleClose={() => setshowReservationDetails(false)}
              Data={selectedReservation}
            />
          )}

          {feedbackModalOpen && (
            <EntityDetails
              open={feedbackModalOpen}
              handleClose={() => setFeedbackModalOpen(false)}
              title={`Détails du contacts`}
              id={selectedReservation?.id}
              value={selectedReservation}
              details={[
                { label: "Sujet", value: selectedReservation?.feedbacks?.sujet },
                { label: "Description", value: selectedReservation?.feedbacks?.description },
              ]}
            />
          )}

          <AlertModalConfirm
            open={modalOpen}
            handleConfirm={() => giveOwnerPayment(selectedReservation)}
            fullName={profile?.companyName || profile?.name + " " + profile?.lastName}
            rib={profile?.rib}
            handleClose={() => setModalOpen(false)}
            message={`Vous êtes sur le point de transférer votre solde vers votre compte bancaire`}
            alertText="Confirmation de transfert"
            alertMsg={
              <div>
                Ce montant va être disponible dans votre compte bancaire après 7 jours, soit le{" "}
                <span className="font-bold">{formatDate(dateAvailable)}</span>.
              </div>
            }
          />

          <div className="flex items-center justify-center mt-11">
            {totalPages > 1 && (
              <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange} />
            )}
          </div>
        </StripeMenu>
      </CommonLayout>
    </div>
  );
};

export default ClientTransfertsPage;
